var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMegaphone = function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "megaphone_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M58.743 60V4L24.706 17.372v26.825zm-38.9-41.492v40.114c-5.37 0-9.724-4.354-9.724-9.725V42.82H5.257V18.507z",
    clipRule: "evenodd"
  })));
};
export { SvgMegaphone as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTU4Ljc0MjggNjBWNEwyNC43MDYzIDE3LjM3MTVWNDQuMTk3M0w1OC43NDI4IDYwWk0xOS44NDM5IDE4LjUwNzVWNTguNjIyQzE0LjQ3MzEgNTguNjIyIDEwLjExOTIgNTQuMjY4IDEwLjExOTIgNDguODk3M1Y0Mi44MTkzSDUuMjU2ODRWMTguNTA3NUgxOS44NDM5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";